/* eslint-disable jsx-a11y/control-has-associated-label */

'use client';

import { useId, useState, useEffect } from 'react';
import classnames from 'classnames';
import Select from 'react-select';
import { Row, Col } from 'reactstrap';

// Services
import { isIdIncludes } from '../../../services/options.service';

function AttributeIdOption({
  attrName, label, id, value, strict, update,
  disable, idList, isInvalid, hideCheck, disableValidation,
}) {
  const inputId1 = useId();
  const inputId2 = useId();
  const spanId = useId();
  const datalistId = useId();
  const ids = idList.map((elem) => ({ value: elem, label: elem }));
  const [isChanged, setIsChanged] = useState(value?.length > 0);
  const [input, setInput] = useState(value);
  const [input2, setInput2] = useState(null);
  const [toggle, setToggle] = useState(strict);

  const onChange = (e) => {
    setIsChanged(true);
    setInput(e.target.value);
    update(id, attrName, e.target.value);
  };

  const onChangeSelect = (e) => {
    const value = e ? e.value : null;
    setInput2(value === null ? '' : value);
    update(id, attrName, value === null ? '' : value);
  };

  const onCheck = (e) => {
    update(id, 'elemIdAll', !toggle);
    setToggle(!toggle);
    if (e.target.checked) {
      update(id, [attrName, 'elemIdAll'], [input2, e.target.checked]);
    } else {
      update(id, [attrName, 'elemIdAll'], [input, e.target.checked]);
    }
  };

  useEffect(() => {
    if (!idList.includes(input2)) {
      setInput2(null);
    }
  }, [idList, input2, value]);

  const isFoundAll = isIdIncludes(idList, value, hideCheck ? true : strict);
  const errorState = (!isFoundAll || isInvalid) && isChanged && !disableValidation && !disable;
  const validState = isFoundAll && isChanged && !errorState && !disableValidation && !disable;

  const customStyles = {
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
    menu: (provided) => ({ ...provided, zIndex: 9999 }),
  };

  useEffect(() => {
    setTimeout(() => {
      setInput2(value);
      setInput(value);
    }, 100);
  }, []);

  // useEffect(() => {
  //   console.log(idList);
  //   setInput2();
  // }, [idList]);

  return (
    <>
      <label htmlFor={inputId1} className="form-label">{label}</label>
      {toggle
        ? (
          <>
            <Col xs="12" md="6" lg="6" className="mb-2">
              <Row>
                <Select
                  id={inputId1}
                  isClearable
                  isDisabled={disable}
                  isSearchable
                  value={{ value: input2, label: input2 }}
                  options={ids}
                  noOptionsMessage={() => ('No id was found in your uploaded files')}
                  onChange={onChangeSelect}
                  placeholder="Select an id..."
                  // menuPortalTarget={document.body}
                  menuPosition="fixed"
                  styles={customStyles}
                />
              </Row>
            </Col>
            <Col xs="12" md="4" lg="4" className="mb-2">
              <Row>
                {!hideCheck ? (
                  <div className="form-check m-auto mx-1 mt-1">
                    <input
                      id={inputId2}
                      className="form-check-input"
                      type="checkbox"
                      checked={toggle}
                      default={toggle}
                      disabled={disable}
                      onChange={onCheck}
                    />
                    <label className="form-check-label m-auto" htmlFor={inputId2}>
                      Strict search
                    </label>
                  </div>
                ) : null}
              </Row>
            </Col>
          </>
        )
        : (
          <Col xs="12" md="8" lg="8">
            <Row>
              <div className="input-group has-validation mb-2">
                <input
                  aria-label={label}
                  aria-describedby={spanId}
                  className={classnames('form-control', { 'is-invalid': errorState, 'is-valid': validState })}
                  disabled={disable}
                  list={datalistId}
                  value={input}
                  onChange={onChange}
                  placeholder="Type to search..."
                />

                <datalist id={datalistId}>
                  {ids.map((elem) => <option key={elem.value} value={elem.value} />)}
                </datalist>
                {!hideCheck ? (
                  <div className="form-check m-auto mx-1">
                    <input
                      id={inputId2}
                      className="form-check-input"
                      type="checkbox"
                      checked={toggle}
                      default={toggle}
                      disabled={disable}
                      onChange={onCheck}
                    />
                    <label className="form-check-label m-auto" htmlFor={inputId2}>
                      Strict search
                    </label>
                  </div>
                ) : null}
                <div className="valid-feedback">
                  ID found!
                </div>
                <div id="validationServerUsernameFeedback" className="invalid-feedback">
                  {isInvalid ? (
                    <>
                      id cannot be empty or used
                      {' '}
                      <a
                        href="https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/id"
                        target="blank"
                      >
                        forbidden characters
                      </a>
                    </>
                  ) : null}
                  {!isFoundAll && !isInvalid ? 'ID not found' : null}
                </div>
              </div>
            </Row>
          </Col>

        )}

    </>
  );
}

export default AttributeIdOption;
